export default function Corner() {
    const $corners = $(".corner");
    const WIN = $(window);;
    const cornersData = [];
    let heigthAnimation;
    let windowHeight;
    init();
    function init() {
        getDetails();
        controllAnimation();
        setEvents();
        setTimeout(() => {
            getDetails();
        }, 1000)
    }
    function getDetails() {
        windowHeight = WIN.height();
        heigthAnimation = windowHeight / 2;
        cornersData.length = 0;
        $corners.each(function () {
            let obj = {};
            let height = $(this).height();
            let innerHeight = $(this).innerHeight();
            obj.transform = height === innerHeight ? false : innerHeight - height + 1;
            obj.top = $(this).offset().top;
            obj.height = height;
            obj.bottom = obj.top + innerHeight;
            obj.rotate = $(this).hasClass("is-rotate") ? true : false;
            cornersData.push(obj);
        });
    }
    function setEvents() {
        WIN.on("resize", function () {
            setTimeout(() => {
                getDetails();
                controllAnimation();
            }, 500);

        });
        WIN.on("scroll", function () {
            controllAnimation();
        });
    }
    function controllAnimation() {
        let scrollTop = WIN.scrollTop();
        let scrollBottom = scrollTop + windowHeight;
        $corners.each(function (i, el) {
            let data = cornersData[i];
            if (data.top < scrollBottom && data.bottom >= scrollTop) {
                let percent = getPercent(scrollBottom, data.bottom, heigthAnimation);
                setAnimation(data.rotate, data.transform, percent, this);
            }
        });
    }
    function setAnimation(rotate, transform, percent, block) {
        let corner = $(block).find(".corner-block");
        if (transform) {
            $(block).css("transform", `translateY(${transform - percent * transform}px)`);
        }
        if (rotate) {
            corner.css(
                "clip-path",
                `polygon(0 0, 0 ${percent * 100}%, 100% 0)`
            );
        } else {
            corner.css(
                "clip-path",
                `polygon(100% ${((1 - percent) * 100)}%, 0 100%, 100% 100%)`
            );
        }
    }
    function getPercent(p1, p2, h) {
        let percent = 1 - (p1 - p2) / h;
        if (percent >= 1) percent = 1;
        if (percent <= 0) percent = 0;
        return percent;
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/Сorner.js